import React, {useContext, useEffect, useState} from "react";
import {Colors} from "../colors";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {TouchableOpacity} from "react-native";
import {AnimatedCheckIcon} from "./AnimatedCheckIcon";
import {RowSpace} from "./_CommonComponents";
import Text from "./Text";

export function RadioGroup<T>(props: { items: { text: string, value: T }[], selected: T, onItemChange: (val: T) => void }) {
    const [selectedIndex, setSelectedIndex] = useState(0);
    useEffect(()=>{
        props.onItemChange(props.items[selectedIndex].value);
    },[selectedIndex]);
    return <>
        {props.items.map((item, index) => {
            return <RadioButton text={item.text} check={props.selected == item.value} key={index} onCheck={()=>setSelectedIndex(index)}/>
        })}
    </>
}

export function RadioButton(props: { text: string, check: boolean, onCheck: ()=>void}) {
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    return <TouchableOpacity style={{
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center"
    }} onPress={props.onCheck}>
        <AnimatedCheckIcon type={"radio"} color={colors.get("secondryColor") as string} check={props.check}/>
        <RowSpace/>
        <Text size={14} color={colors.get("lowConText") as string} weight={600}>{props.text}</Text>
        <RowSpace/>
        <RowSpace/>
    </TouchableOpacity>
}

